import { EEmptyState } from '../TableEmptyContent.constants';
export default function getState(isFiltered, searchValue) {
  let state = EEmptyState.emptyState;
  if (searchValue != null && searchValue.length) {
    state = EEmptyState.searchState;
    return state;
  }
  if (isFiltered) {
    state = EEmptyState.filterState;
    return state;
  }
  return state;
}